import { CompanyUser } from '@/api';
import { ReactElement, ReactNode } from 'react';
import { MemberContext, MemberContextData } from './context';

type MemberProviderProps = {
    readonly companyUser: CompanyUser;
    readonly children?: ReactNode;
};

export function MemberProvider({
    companyUser,
    children
}: MemberProviderProps): ReactElement {
    const value: MemberContextData = {
        companyUser
    };

    return (
        <MemberContext.Provider value={value}>
            {children}
        </MemberContext.Provider>
    );
}
